// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"25aab4be","119":"98cc853c","275":"e4c829aa","301":"69a573fd","307":"6f0c79b3","347":"8d1783a2","407":"7f785de6","539":"d5cf32bc","556":"678be3cd","679":"66e1726e","701":"b7ac1f7c","777":"19c38c67","926":"53b61e03"}[chunkId] + ".chunk.js";
};